import Button from './ui/Button.jsx';
import Pill from './ui/Pill.jsx';
import Eyebrow from './ui/Eyebrow.jsx';
import Reveal from './ui/Reveal.jsx';

export default function Hero() {
  return (
    <section
      id="top"
      data-screen-label="01 Hero"
      className="hero"
      style={{
        background: 'var(--cream)',
        paddingTop: 140,
        paddingBottom: 'var(--space-10)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        className="hero-grid"
        style={{
          maxWidth: 'var(--maxw-content)',
          margin: '0 auto',
          padding: '0 var(--gutter)',
          display: 'grid',
          gridTemplateColumns: '1.1fr 0.9fr',
          gap: 80,
          alignItems: 'center',
        }}
      >
        <Reveal>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
            <Pill tone="success" dot>
              Plek beschikbaar
            </Pill>
            <Eyebrow>GZ-psycholoog (BIG) · Amsterdam</Eyebrow>
          </div>

          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 400,
              fontSize: 'clamp(48px, 6vw, 84px)',
              lineHeight: 1.04,
              letterSpacing: '-0.015em',
              color: 'var(--ink)',
              margin: 0,
            }}
          >
            Een rustige,
            <br />
            <span style={{ fontStyle: 'italic' }}>persoonlijke </span>
            benadering.
          </h1>

          <p
            className="hero-lede"
            style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 300,
              fontSize: 21,
              lineHeight: 1.55,
              color: 'var(--ink-2)',
              marginTop: 28,
              maxWidth: '46ch',
            }}
          >
            Ik bied online behandeling en psychodiagnostisch onderzoek. Iedere behandeling stem ik
            af op wie er voor mij zit — jouw verhaal, jouw tempo.
          </p>

          <div className="hero-actions" style={{ display: 'flex', gap: 12, marginTop: 40 }}>
            <Button href="#contact">Maak een afspraak</Button>
            <Button variant="secondary" href="#behandeling">
              Bekijk behandelingen
            </Button>
          </div>
        </Reveal>

        <Reveal
          delay={180}
          className="hero-portrait"
          style={{
            width: '100%',
            aspectRatio: '4 / 5',
            backgroundImage: "url('/assets/portrait-maxime.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center top',
            borderRadius: 'var(--radius-md)',
            boxShadow: 'var(--shadow-card)',
          }}
        />
      </div>
    </section>
  );
}
